import { mapActions, mapGetters, mapMutations } from 'vuex'
import { updatePayMethod } from '../../../apis/payment'
import { legacyCreditCardGateWay, PAYMENT_ACTION_TYPE, PaymentComponentName } from '../../../common/constant'
import emitter from '../../../common/mixins/emitter'
import { getCurrency } from '../../../utils/currency'
import { getDefaultCvvReAuthInfo } from '../../../store/helper'
import { APP_NAMESPACE } from '../../../store'
import Ready from '../../../common/ready'

export default {
  mixins: [emitter],
  props: {
    paymethod: String,
    saveDisabled: Boolean
  },
  inject: ['isPrimary', 'action', 'account', 'payment'],
  data() {
    return {
      formLoading: false,
      paymentError: '',
      submitLoading: false,
      rootReady: new Ready()
    }
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, [
      'billingInfo',
      'withCcAccount',
      'billToAddress',
      'soldToContact',
      'gatewayInfo',
      'addressInfo',
      'countryMap',
      'taxInfo',
      'isInEnrollAutopayFlow'
    ]),
    paymentGateway() {
      const gwMap = this.gatewayInfo
      const countryCode = this.countryCode
      const currency = getCurrency()
      const gateway = gwMap[`${countryCode}_${currency}`] || gwMap[`DEFAULT_${currency}`] || gwMap['DEFAULT_DEFAULT']
      return gateway === undefined ? legacyCreditCardGateWay : gateway
    },
    countryCode() {
      return this.billToAddress?.country || 'DEFAULT'
    },
    isCvvReAuth() {
      return this.action === PAYMENT_ACTION_TYPE.UPDATE_EXPIRATION
    }
  },
  methods: {
    ...mapMutations(APP_NAMESPACE, ['setCvvReAuthInfo']),
    ...mapActions(APP_NAMESPACE, ['paymentFormReady']),
    clearPaymentError() {
      this.paymentError = ''
    },
    changePaymentTileStatus(isActive = false) {
      if (!isActive) {
        this.dispatch(PaymentComponentName, 'clear-update-status')
      }
      this.dispatch(PaymentComponentName, 'change-tile-status', isActive)
    },
    toggleFormSubmitLoading(submitLoading) {
      this.submitLoading = submitLoading
    },
    async updatePayMethodApi(paymentInfo = {}) {
      const { zAccountId } = this.billingInfo
      const { paymentResponse, paymentGateway, creditCardReAuth = false } = paymentInfo
      const params = {
        paymentInfo: {
          zAccountId,
          paymentGateway,
          paymentResponse,
          creditCardReAuth
        }
      }
      if (this.isInEnrollAutopayFlow) {
        params.fromMigrationAutoPay = true
      }
      const data = await updatePayMethod(params)
      if (!data.result) {
        return Promise.reject(data.errorMessage ?? 'unKnow error')
      }
    },
    async updatePayMethod(paymentInfo = {}) {
      if (this.withCcAccount) {
        await this.updatePayMethodApi(paymentInfo)
        // clear any cvv reauth state
        this.setCvvReAuthInfo(getDefaultCvvReAuthInfo())
      }
      return Promise.resolve(paymentInfo)
    },

    ready() {
      this.paymentFormReady(this.paymethod)
    }
  },
  mounted() {
    this.rootReady.solved()
  }
}
